import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';
import { Loader2 } from 'lucide-react';
import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export const variantesBoton = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-[background-color,color,border-color,box-shadow,transform] duration-150 disabled:pointer-events-none disabled:opacity-45 active:scale-[0.98] [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      variante: {
        primario: 'bg-primary text-on-primary hover:bg-primary/88 shadow-hoja',
        acento: 'bg-accent text-on-accent hover:bg-accent/90 shadow-hoja',
        secundario: 'border border-border bg-surface text-foreground hover:bg-muted',
        fantasma: 'text-foreground hover:bg-muted',
        peligro: 'bg-destructive text-white hover:bg-destructive/90',
        enlace: 'text-accent underline-offset-4 hover:underline px-0',
      },
      tamano: {
        sm: 'h-8 px-3 text-[13px]',
        md: 'h-9 px-4',
        lg: 'h-11 px-6 text-[15px]',
        icono: 'size-9',
      },
    },
    defaultVariants: { variante: 'primario', tamano: 'md' },
  },
);

export interface BotonProps extends ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof variantesBoton> {
  asChild?: boolean;
  cargando?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, BotonProps>(
  ({ className, variante, tamano, asChild, cargando, disabled, children, ...props }, ref) => {
    const Componente = asChild ? Slot : 'button';
    return (
      <Componente
        ref={ref}
        className={cn(variantesBoton({ variante, tamano }), className)}
        disabled={disabled || cargando}
        aria-busy={cargando || undefined}
        {...props}
      >
        {asChild ? (
          children
        ) : (
          <>
            {cargando && <Loader2 className="animate-spin" aria-hidden />}
            {children}
          </>
        )}
      </Componente>
    );
  },
);
Button.displayName = 'Button';
